import { api } from "..";

import { QueryProps } from "@/types/Api";

export interface CouponAuditFinding {
  id: number;
  couponId: string;
  userId: number;
  username: string;
  totalStake: number | null;
  /** Unique match ids ("5|614015") whose legs disagree with the recompute. */
  suspectMatches: string[];
  storedStatus: string;
  recomputedStatus: string;
  storedPayout: number | null;
  recomputedReturn: number;
  /** Human-readable per-leg breakdown from the audit job. */
  detail: string;
  status: "open" | "resolved";
  resolution: "auto" | "manual" | null;
  foundAt: string;
  resolvedAt: string | null;
}

export interface CouponAuditFindingsResponse {
  openCount: number;
  /** Last completed audit run (shared across admins); null before first run. */
  lastRun: {
    finishedAt: string;
    checked: number;
    mismatches: number;
  } | null;
  findings: CouponAuditFinding[];
}

interface GetCouponAuditFindingsParams {
  status?: "open" | "resolved" | "all";
  limit?: number;
}

export const getCouponAuditFindings = async (
  props: QueryProps<GetCouponAuditFindingsParams>
): Promise<CouponAuditFindingsResponse> => {
  const res = await api.client.get(`/users-new/coupons/audit/findings`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};

export const resolveCouponAuditFinding = async (
  findingId: number
): Promise<{ resolved: boolean }> => {
  const res = await api.client.post(
    `/users-new/coupons/audit/findings/${findingId}/resolve`
  );
  return res.data;
};

export const fixCouponAuditFinding = async (
  findingId: number
): Promise<{ reverted: number; missingMatches: string[] }> => {
  const res = await api.client.post(
    `/users-new/coupons/audit/findings/${findingId}/fix`
  );
  return res.data;
};

export const triggerCouponAuditScan = async (): Promise<{
  queued: boolean;
}> => {
  const res = await api.client.post(`/users-new/coupons/audit/scan`);
  return res.data;
};
